import { DataTable } from "primereact/datatable";
import Dashboard from "../Layout/Dashboard";
import { Column } from "primereact/column";
import { //Link,
   useSearchParams } from "react-router-dom";
import { currencyFormat } from "../utils";
import { useEffect, useState } from "react";
import { FilterMatchMode } from "primereact/api";
import { ProgressSpinner } from "primereact/progressspinner";
import {
  // useCurrentDollarRate,
  useClients,
  useMedicalCenterFund,
  // useGetInsurance,
} from "../hooks/queries";
import { Dropdown } from "primereact/dropdown";
import { FundType } from "../constants";

/**
 * Applies currency format to the given number for the datatable
 * @param {string} key
 */
function createCurrencyTemplate(key) {
  return (row) => currencyFormat(row[key]);
}

// ...existing helper functions like createCurrencyTemplate, consumedPercentageTemplate, etc...

export default function MainFundListing() {
  const [filters] = useState({
    medical_center_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    consumed: { value: null, matchMode: FilterMatchMode.CUSTOM },
  });

  const [searchParams, setSearchParams] = useSearchParams();
  const [client, setClient] = useState(null);
  const clientsQuery = useClients(false, FundType.POSTPAY);

  useEffect(() => {
    const clientIdFromUrl = searchParams.get("cliente");
    if (clientIdFromUrl && clientsQuery.data) {
      const matchedClient = clientsQuery.data.find(
        (c) => c.id === parseInt(clientIdFromUrl, 10)
      );
      if (matchedClient) {
        setClient(matchedClient);
      }
    }
  }, [searchParams, clientsQuery.data]);

  const providersFundQuery = useMedicalCenterFund({
    clientID: client?.id,
  });

  // const dollarRateQuery = useCurrentDollarRate();
  // const dollarRate = dollarRateQuery.data?.rate ?? 0;

  // const [
  //   totalFund,
  //   totalIncurred,
  //   totalAvailable,
  // ] = providersFundQuery.isLoading
  //   ? [null, null, null]
  //   : [
  //       providersFundQuery.data?.reduce(
  //         (prev, provider) =>
  //           prev + Number(provider ? provider.amount_advance : 0),
  //         0
  //       ) ?? 0,
  //       providersFundQuery.data?.reduce(
  //         (prev, provider) =>
  //           prev + Number(provider ? provider.amount_incurred : 0),
  //         0
  //       ) ?? 0,
  //       providersFundQuery.data?.reduce(
  //         (prev, provider) =>
  //           prev + Number(provider ? provider.amount_available : 0),
  //         0
  //       ) ?? 0,
  //     ];
  // const totalPercentageConsumed = Number(
  //   (totalIncurred / totalFund) * 100
  // ).toFixed(2);

  // const useInsurance = useGetInsurance();
  // const insurance = useInsurance?.data;

  return (
    <Dashboard headerTitle="Resumen de Fondos Incurridos">
      <div className="p-2 p-fluid">
        {/* Summary Section */}
        <div className="advance-summary-container">
          {/* ...summary cards for dollar rate, total fund, incurred, available... */}
        </div>
        <div className="flex w-full">
          {providersFundQuery.isLoading ? (
            <ProgressSpinner />
          ) : (
            <div className="mb-2 mt-1 text-lg font-bold	w-full">
              {/* {consumedPercentageTemplate({
                consumed: totalPercentageConsumed,
              })} */}
            </div>
          )}
        </div>
        <div className="p-field">
          <label htmlFor="clients">Cliente</label>
          <Dropdown
            id="clients"
            name="clients"
            options={clientsQuery.data ?? []}
            dataKey="id"
            optionLabel="name"
            value={client}
            onChange={(e) => {
              setClient(e.value);
              setSearchParams({ cliente: e.value?.id });
            }}
            placeholder="Seleccione el Cliente"
            emptyMessage="No hay clientes disponibles"
          />
        </div>
        <DataTable
          value={providersFundQuery.data ?? []}
          stripedRows
          showGridlines
          resizableColumns
          paginator
          alwaysShowPaginator={false}
          rows={15}
          rowsPerPageOptions={[10, 15, 25, 50]}
          selectionMode="single"
          dataKey="medical_center"
          filters={filters}
          filterDisplay="row"
          removableSort
          emptyMessage="No se hallaron proveedores."
          loading={providersFundQuery.isLoading}
        >
          {/* Columns for medical center, fund, incurred, available, etc. */}
          <Column
            field="medical_center_name"
            header="Centro Médico"
            filter
            filterPlaceholder="Buscar centro médico"
            filterMatchMode={FilterMatchMode.CONTAINS}
          />
          <Column
            field="amount_incurred"
            header="Incurrido"
            sortable
            body={createCurrencyTemplate("amount_incurred")}
          />

          <Column
            field="amount_advance"
            header="Pagado"
            sortable
            body={createCurrencyTemplate("amount_advance")}
          />

          <Column
            field="amount_debit"
            header="Debe"
            sortable
            body={createCurrencyTemplate("amount_debit")}
          />
          {/* <Column
            header="Acción"
            body={(row) => (
              <Link
                to={`proveedores/${row.medical_center}?cliente=${client?.id}`}
                className="p-button"
              >
                <span className="p-button-icon p-button-icon-left pi pi-eye"></span>
                <span className="p-button-label">Ver pagos</span>
              </Link>
            )}
          /> */}
        </DataTable>
      </div>
    </Dashboard>
  );
}
